import { ImageModule } from 'Angular/features/directives/image/image.module';
import * as i0 from "@angular/core";
export class PasswordRevealModule {
}
PasswordRevealModule.ɵfac = function PasswordRevealModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PasswordRevealModule)(); };
PasswordRevealModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PasswordRevealModule });
PasswordRevealModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [ImageModule] });
